import { Breadcrumbs, Breadcrumb } from "@conuti-das/prince-ui";
import { RunComposer } from "@/components/runs/RunComposer";
import runsData from "@/data/generated/runs.json";
import type { Run } from "@/types";

export function NewRunPage() {
  const known = Array.from(new Set((runsData as Run[]).map(r => r.release))).sort();
  if (known.length === 0) known.push("202610");
  return (
    <div className="page">
      <Breadcrumbs>
        <Breadcrumb><span>Runs</span></Breadcrumb>
        <Breadcrumb><span>Neuer Run</span></Breadcrumb>
      </Breadcrumbs>
      <div className="page-header" style={{ marginTop: "var(--s-3)" }}>
        <h2 className="page-title">Neuer Run anlegen</h2>
      </div>
      <RunComposer knownReleases={known} />
    </div>
  );
}
